var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/primitives.ts
import { z } from "zod";
var UuidSchema = z.string().uuid();
var UuidParams = z.object({
  id: UuidSchema
});

export {
  __name,
  UuidSchema,
  UuidParams
};
//# sourceMappingURL=chunk-KDZI72TC.js.map